import { io } from 'socket.io-client';

const authData = JSON.parse(localStorage.getItem('AuthData'));
const sessionData = sessionStorage.getItem('ap-session-id');

export const socket = io(
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_BACKEND_DEV_API_URL
    : process.env.REACT_APP_BACKEND_PRODUCTION_API_URL,
  {
    extraHeaders: {
      'x-user-type': authData && authData.type,
      'x-user-id': authData && authData.user_id,
      'x-session-key': sessionData && String(sessionData).length > 0 ? sessionData : undefined,
    },
  }
);
